import { ReactNode } from "react";

export interface MDSConfigurationListRowProps {
  children?: ReactNode;
  title: string | ReactNode;
  description?: string | ReactNode;
  isExpanded?: boolean;
}

export enum MDSConfigurationListRowSlotName {
  LeftAddon = "icon-left",
  RightAddon = "right-addon",
  ExpandedContent = "expanded-content",
  ButtonsBottom = "buttons-bottom",
}
